import { useTranslation } from "react-i18next";
import SuccessModal from "components/SuccessModal";

interface UpsellRequestSuccessModalProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Confirmation shown after a successful "Request access" submission. The card, timer and live
 * region all live in the shared `SuccessModal`; this only supplies the copy.
 */
function UpsellRequestSuccessModal(props: UpsellRequestSuccessModalProps) {
  const { open, onClose } = props;

  const { t } = useTranslation();

  return <SuccessModal open={open} onClose={onClose} message={t("upsell.request_access_success_message")} />;
}

export default UpsellRequestSuccessModal;
